export function OkxCredentialSection({ okxCredentials }) {
  return (
    <>
      <div className="divider-line" />
      <div className="panel-head compact">
        <span className="label">EXCHANGE CONNECTION</span>
        <span className={okxCredentials.configured ? "paper-safe" : "live-warning"} data-testid="okx-credential-state">
          {okxCredentials.configured ? "CONNECTED" : "PAPER ONLY"}
        </span>
      </div>
      <div className="range-box" data-testid="exchange-connection-note">
        <span>MODE <b className="mono">{okxCredentials.configured ? "LIVE READY" : "PAPER"}</b></span>
        <span>SETUP <b className="mono">ADMIN MANAGED</b></span>
      </div>
    </>
  );
}